function installSupplyThemeConfigurationTokens(wtgUi) {
  const colors = wtgUi.theme.colors.toVuetifyOptions();
  const appearance = wtgUi.appearance;
  const lightColors = appearance === 'muted' ? colors.muted : colors.light;
  const primaryColor = wtgUi.dark ? colors.dark.primary : lightColors.primary;
  const brandColor = wtgUi.dark ? colors.dark.brand : lightColors.brand;
  resetSupplyColorTokens('light', 'primary');
  resetSupplyColorTokens('dark', 'primary');
  resetSupplyColorTokens('light', 'brand');
  resetSupplyColorTokens('dark', 'brand');
  if (appearance === 'light' && primaryColor.toUpperCase() !== '#0022CC') {
    applySupplyColorTokens(appearance, 'primary');
  }
  if (appearance === 'light' && brandColor.toUpperCase() !== '#371EE1') {
    applySupplyColorTokens(appearance, 'brand');
  }
  if (appearance === 'muted' && primaryColor.toUpperCase() !== '#1C1C1B') {
    applySupplyColorTokens(appearance, 'primary');
  }
  if (appearance === 'muted' && brandColor.toUpperCase() !== '#30302E') {
    applySupplyColorTokens(appearance, 'brand');
  }
  if (appearance === 'dark' && primaryColor.toUpperCase() !== '#7486DC') {
    applySupplyColorTokens(appearance, 'primary');
  }
  if (appearance === 'dark' && brandColor.toUpperCase() !== '#181C33') {
    applySupplyColorTokens(appearance, 'brand');
  }
  const root = document.querySelector(':root');
  const brandAppColors = wtgUi.appearance === 'dark' ? wtgUi.theme.colors.dark.app : wtgUi.appearance === 'muted' ? wtgUi.theme.colors.muted.app : wtgUi.theme.colors.light.app;
  root.style.setProperty('--s-brand-txt-base', brandAppColors.brandColorDark ? '#FFFFFF' : '#30302e');
  root.style.setProperty('--s-brand-login-txt-base', brandAppColors.brandLoginColorDark ? '#FFFFFF' : '#30302e');
}
function resetSupplyColorTokens(appearance, color) {
  const root = document.querySelector(':root');
  root.style.removeProperty(`--s-${appearance}-${color}-1000`);
  root.style.removeProperty(`--s-${appearance}-${color}-900`);
  root.style.removeProperty(`--s-${appearance}-${color}-800`);
  root.style.removeProperty(`--s-${appearance}-${color}-700`);
  root.style.removeProperty(`--s-${appearance}-${color}-600`);
  root.style.removeProperty(`--s-${appearance}-${color}-500`);
  root.style.removeProperty(`--s-${appearance}-${color}-400`);
  root.style.removeProperty(`--s-${appearance}-${color}-300`);
  root.style.removeProperty(`--s-${appearance}-${color}-200`);
  root.style.removeProperty(`--s-${appearance}-${color}-100`);
  root.style.removeProperty(`--s-${color}-bg-default`);
  root.style.removeProperty(`--s-${color}-bg-hover`);
  root.style.removeProperty(`--s-${color}-bg-active`);
  root.style.removeProperty(`--s-${color}-bg-weak-default`);
  root.style.removeProperty(`--s-${color}-bg-weak-hover`);
  root.style.removeProperty(`--s-${color}-bg-weak-active`);
  root.style.removeProperty(`--s-${color}-txt-default`);
  root.style.removeProperty(`--s-${color}-txt-hover`);
  root.style.removeProperty(`--s-${color}-txt-active`);
  root.style.removeProperty(`--s-${color}-txt-weak-default`);
  root.style.removeProperty(`--s-${color}-txt-weak-hover`);
  root.style.removeProperty(`--s-${color}-txt-weak-active`);
  root.style.removeProperty(`--s-${color}-txt-inv-default`);
  root.style.removeProperty(`--s-${color}-txt-inv-hover`);
  root.style.removeProperty(`--s-${color}-txt-inv-active`);
  root.style.removeProperty(`--s-${color}-txt-weak-inv-default`);
  root.style.removeProperty(`--s-${color}-txt-weak-inv-hover`);
  root.style.removeProperty(`--s-${color}-txt-weak-inv-active`);
  root.style.removeProperty(`--s-${color}-icon-default`);
  root.style.removeProperty(`--s-${color}-icon-hover`);
  root.style.removeProperty(`--s-${color}-icon-active`);
  root.style.removeProperty(`--s-${color}-icon-weak-default`);
  root.style.removeProperty(`--s-${color}-icon-weak-hover`);
  root.style.removeProperty(`--s-${color}-icon-weak-active`);
  root.style.removeProperty(`--s-${color}-icon-inv-default`);
  root.style.removeProperty(`--s-${color}-icon-inv-hover`);
  root.style.removeProperty(`--s-${color}-icon-inv-active`);
  root.style.removeProperty(`--s-${color}-icon-weak-inv-default`);
  root.style.removeProperty(`--s-${color}-icon-weak-inv-hover`);
  root.style.removeProperty(`--s-${color}-icon-weak-inv-active`);
  root.style.removeProperty(`--s-${color}-border-default`);
  root.style.removeProperty(`--s-${color}-border-hover`);
  root.style.removeProperty(`--s-${color}-border-active`);
}
function applySupplyColorTokens(appearance, color) {
  const root = document.querySelector(':root');
  const neutralLighten6 = '#f8f8f7';
  const neutralLighten5 = '#f1f1ef';
  root.style.setProperty(`--s-${appearance}-${color}-1000`, `var(--v-${color}-darken3)`);
  root.style.setProperty(`--s-${appearance}-${color}-900`, `var(--v-${color}-darken2)`);
  root.style.setProperty(`--s-${appearance}-${color}-800`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${appearance}-${color}-700`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${appearance}-${color}-600`, `var(--v-${color}-lighten1)`);
  root.style.setProperty(`--s-${appearance}-${color}-500`, `var(--v-${color}-lighten2)`);
  root.style.setProperty(`--s-${appearance}-${color}-400`, `var(--v-${color}-lighten3)`);
  root.style.setProperty(`--s-${appearance}-${color}-300`, `var(--v-${color}-lighten4)`);
  root.style.setProperty(`--s-${appearance}-${color}-200`, neutralLighten5);
  root.style.setProperty(`--s-${appearance}-${color}-100`, neutralLighten6);
  root.style.setProperty(`--s-${color}-bg-default`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${color}-bg-hover`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${color}-bg-active`, `var(--v-${color}-darken2)`);
  root.style.setProperty(`--s-${color}-bg-weak-default`, neutralLighten6);
  root.style.setProperty(`--s-${color}-bg-weak-hover`, neutralLighten5);
  root.style.setProperty(`--s-${color}-bg-weak-active`, `var(--v-${color}-lighten4)`);
  root.style.setProperty(`--s-${color}-txt-default`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${color}-txt-hover`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${color}-txt-active`, `var(--v-${color}-darken2)`);
  root.style.setProperty(`--s-${color}-txt-weak-default`, `var(--v-${color}-lighten1)`);
  root.style.setProperty(`--s-${color}-txt-weak-hover`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${color}-txt-weak-active`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${color}-txt-inv-default`, neutralLighten6);
  root.style.setProperty(`--s-${color}-txt-inv-hover`, neutralLighten5);
  root.style.setProperty(`--s-${color}-txt-inv-active`, '#ffffff');
  root.style.setProperty(`--s-${color}-txt-weak-inv-default`, `var(--v-${color}-lighten4)`);
  root.style.setProperty(`--s-${color}-txt-weak-inv-hover`, neutralLighten5);
  root.style.setProperty(`--s-${color}-txt-weak-inv-active`, neutralLighten6);
  root.style.setProperty(`--s-${color}-icon-default`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${color}-icon-hover`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${color}-icon-active`, `var(--v-${color}-darken2)`);
  root.style.setProperty(`--s-${color}-icon-weak-default`, `var(--v-${color}-lighten1)`);
  root.style.setProperty(`--s-${color}-icon-weak-hover`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${color}-icon-weak-active`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${color}-icon-inv-default`, neutralLighten6);
  root.style.setProperty(`--s-${color}-icon-inv-hover`, neutralLighten5);
  root.style.setProperty(`--s-${color}-icon-inv-active`, '#ffffff');
  root.style.setProperty(`--s-${color}-icon-weak-inv-default`, `var(--v-${color}-lighten4)`);
  root.style.setProperty(`--s-${color}-icon-weak-inv-hover`, neutralLighten5);
  root.style.setProperty(`--s-${color}-icon-weak-inv-active`, neutralLighten6);
  root.style.setProperty(`--s-${color}-border-default`, `var(--v-${color}-base)`);
  root.style.setProperty(`--s-${color}-border-hover`, `var(--v-${color}-darken1)`);
  root.style.setProperty(`--s-${color}-border-active`, `var(--v-${color}-darken2)`);
}

export { installSupplyThemeConfigurationTokens };
